const Home = () =>{
    return (
        <h1>Welcome to our home!</h1>
    )
}
export default Home;